import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-night">
      <div className="mx-auto max-w-[1400px] px-5 pt-16 sm:px-8 md:pt-20">
        <div className="flex flex-wrap items-end justify-between gap-8 border-b border-line pb-10">
          <img
            src="/assets/logo-white.png"
            alt="chroma."
            className="w-[min(58vw,300px)]"
            width="300"
            height="74"
            loading="lazy"
          />
          <p className="max-w-xs font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-muted">
            Plateforme culturelle &amp; médiatique — musiques électroniques, cultures
            latino-américaines, scène underground. Lyon, France.
          </p>
        </div>

        <div className="grid gap-10 py-12 sm:grid-cols-2 md:grid-cols-3">
          <nav aria-label="Navigation de pied de page">
            <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.35em] text-ice">
              <span className="h-2 w-2 bg-glow" aria-hidden="true" />
              Navigation
            </p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-${link.testid}`}
                    className="link-underline text-base text-fog/85 transition-colors hover:text-fog"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.35em] text-ice">
              <span className="h-2 w-2 bg-glow" aria-hidden="true" />
              Suivre Chroma
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={CONTACT.instagram.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="group inline-flex items-center gap-1.5 text-base text-fog/85 transition-colors hover:text-ice"
                >
                  Instagram
                  <ArrowUpRight
                    size={15}
                    className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.soundcloud.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-soundcloud-link"
                  className="group inline-flex items-center gap-1.5 text-base text-fog/85 transition-colors hover:text-ice"
                >
                  SoundCloud
                  <ArrowUpRight
                    size={15}
                    className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email-link"
                  className="link-underline text-base text-fog/85 transition-colors hover:text-glow"
                >
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.35em] text-ice">
              <span className="h-2 w-2 bg-glow" aria-hidden="true" />
              Mentions légales
            </p>
            <address className="mt-5 space-y-1.5 font-mono text-xs not-italic leading-relaxed text-muted">
              <p className="text-fog">{CONTACT.legal.name}</p>
              <p>{CONTACT.legal.address}</p>
              <p>RNA {CONTACT.legal.rna}</p>
              <p>SIRET {CONTACT.legal.siret}</p>
            </address>
          </div>
        </div>
      </div>

      <div className="border-t border-line">
        <p className="mx-auto max-w-[1400px] px-5 py-6 font-mono text-[11px] leading-relaxed tracking-wider text-muted sm:px-8">
          © 2026 {CONTACT.legal.name} — RNA {CONTACT.legal.rna} — SIRET {CONTACT.legal.siret}
        </p>
      </div>
    </footer>
  );
}
